import './_download-link-list-block.scss'
import { Link } from 'types'
import { ReactComponent as FolderDownloadIcon } from 'assets/icons/folder-download.svg'

interface DownloadLinkListBlockProps {
  files?: Link[]
}

export const DownloadLinkListBlock = ({ files }: DownloadLinkListBlockProps) => {
  return (
    <div className='download-link-list-block'>
      {files && (
        <ul className='download-link-list-block__list'>
          {files.map((link) => (
            <li key={link.url}>
              <a className='download-link-list-block__list__item' href={link.url} download>
                <span>{link.text}</span>
                <FolderDownloadIcon />
              </a>
            </li>
          ))}
        </ul>
      )}
    </div>
  )
}
